const Loader = () => {

	return (
		<div className="loader__container">
			<div className="loader__wrapper">
				<svg className="loader__spinner" viewBox="0 0 100 100">
					<circle
						cx="50"
						cy="50"
						fill="transparent"
						r="25"
						stroke="#b30838"
						strokeWidth="10"
					/>
				</svg>
			</div>
		</div>
	);
}

export default Loader
